import {
  type DomainFormSchema,
  type DomainMutationSchema,
  hostingManagementToStr,
  registrarManagementToStr,
} from '../schemas';

export function domainFormToUpdate({
  hosting_management,
  registrar,
  infrastructure,
  registrar_management,
  client,
  application,
  creator_id,
  ...rest
}: DomainFormSchema & Pick<DomainMutationSchema, 'creator_id'>): DomainMutationSchema {
  return {
    ...rest,
    hosting_management: hostingManagementToStr(hosting_management),
    registrar_management: registrarManagementToStr(registrar_management),
    registrar_id: registrar?.id || null,
    infrastructure_id: infrastructure?.id || null,
    client_id: client?.id || null,
    application_id: application?.id || null,
    creator_id,
  };
}
